import * as Telecom from '@servicetitan/telecom-rtcs-client';
import {
  ServiceUserStats,
  userStatsFromAgentStats,
} from '../../types/ServiceUser';
import requireUser from '../../lib/requireUser';
import log from '../../lib/log';
import isValidUser from '../../lib/isValidUser';
import { ServiceUserUtils } from '../../lib/serviceUserUtils';
import { EventAvailabilityState } from '../../lib/eventAvailabilityState';
import { UserSetAvailabilityStatus } from '@api/generated/graphql';
import { setUserStatus } from '../../lib/userStatus';
import DiagnosticsModule from '@modules/DiagnosticsModule';
import ServiceModule from '@modules/ServiceModule';
import { recordAgentStatusChange } from '../../../metrics/agentStatusChangeHelpers';
import { Source } from '../../../metrics/agentMetrics';
import { RTCSEventType } from '../../../metrics/rtcsMetrics';
import { trackRTCSEventLatency } from '../../lib/trackRTCSEventLatency';

async function handleAgentStatus(event: Telecom.AgentStatusEvent) {
  trackRTCSEventLatency(event.timestamp, RTCSEventType.AGENT_STATUS);

  if (!isValidUser(event.agentId)) {
    return;
  }

  const user = await requireUser(event.agentId);
  log('rtcs:agent:status:' + user?.name, event);

  user.available = event.available;

  user.capacity =
    event.availabilityState === EventAvailabilityState.OnACall ||
    event.availabilityState === EventAvailabilityState.WrapupTime
      ? 0
      : 1;

  const isUserAvailable = ServiceUserUtils.isUserAvailable(user);
  const isUsesStatusUpdateInProgress = ServiceModule.getUserStatusUpdateLoading(
    user.id,
  );

  // Capture current status for metrics (before change)
  const previousStatus = ServiceUserUtils.getAvailabilityStatus(user);

  // If user is available set status to Available, if user not Available
  if (event.available && !isUserAvailable) {
    setUserStatus({
      userId: user.id,
      status: UserSetAvailabilityStatus.Available,
    });

    // Track automatic status change (RTCS-initiated)
    recordAgentStatusChange(
      previousStatus,
      UserSetAvailabilityStatus.Available,
      Source.AUTOMATIC,
    );
  } else if (
    !event.available &&
    isUserAvailable &&
    !isUsesStatusUpdateInProgress
  ) {
    const message = `User wrong status: User ${user.id} is Available but received available=false from RTCS.`;
    DiagnosticsModule.reportUserError({
      message: message,
      priority: 'direct',
    });
  }

  user.stats = event.stats
    ? userStatsFromAgentStats(event.stats)
    : ({} as ServiceUserStats);

  ServiceUserUtils.setEventActivityStatus(user, event.availabilityState);
}

export default handleAgentStatus;
